// this code is for valentis 

// jQuery(document).ready(function(){
// 	if ( navigator.userAgent.search("MSIE") >= 0 ){
// 	    console.log('microsoft browser');
// 	}else{
// 		console.log('not microsoft browser');

// 		// $('body').addClass('not_ms');
// 	}
// });